import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as selectores from "app/features/selectores/index";


interface Datos {
    tipo: models.TipoPersona;
}
interface Props extends kea.ModalProps<Datos, boolean, null> {

}

/**Modal para seleccionar el tipo de persona */
export class TipoPersonaModal extends React.PureComponent<Props>{
    render() {
        return (
            <kea.Modal
                title="Cambiar tipo de persona"
                onClose={() => this.props.onClose(false)}
                buttons={[
                    <kea.GuardarButton onClick={() => this.props.onClose(true)} />
                ]}
            >
                <div className="alert alert-info">
                    Modificar el tipo de persona del receptor recalculando los impuestos, en caso de cambiar de tipo física a moral se agrega un concepto de ajuste para que el total de la factura se conserve,
                    en el caso contrario si este concepto ya existe es eliminado
            </div>

                <selectores.TipoPersona value={this.props.value.tipo} onChange={x => this.props.onChange({ tipo: x! })} label="Tipo de persona" />
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/edit/componentes/tipopersonamodal.tsx